import type { Catalog } from '@smarton-pbx/shared';

/** The phone: the dialer, the call card, phone set-up and the phone app card; how calls ended. */
export const phone: Catalog = {
  // How a call ended (lib/calls; "No answer", "Voicemail" and "Cancelled" are in common).
  'In progress': 'Vyksta',
  'Answered on mobile': 'Atsiliepta mobiliuoju',
  Answered: 'Atsiliepta',
  Missed: 'Praleista',
  Busy: 'Užimta',
  'Not allowed': 'Neleista',
  Failed: 'Nepavyko',

  // The Phone page.
  'Call a colleague by extension, or any phone number. Use a headset for the best sound.':
    'Skambinkite kolegai vidiniu numeriu arba bet kuriuo telefono numeriu. Geriausiam garsui naudokite ausines su mikrofonu.',
  'The microphone is blocked in this browser, so calls can’t work.': 'Mikrofonas šioje naršyklėje užblokuotas, todėl skambučiai negali veikti.',
  'Allow the microphone and notifications so calls work in this browser.': 'Leiskite naudoti mikrofoną ir pranešimus, kad skambučiai veiktų šioje naršyklėje.',
  'How to fix': 'Kaip ištaisyti',
  'Set up': 'Nustatyti',
  'Enter a number': 'Įveskite numerį',
  'Number or extension': 'Numeris arba vidinis numeris',
  'Delete last digit': 'Ištrinti paskutinį skaitmenį',
  'Dial pad': 'Klaviatūra',
  '0, hold for plus': '0, palaikius – pliusas',
  'Hold for +': 'Palaikykite, kad įvestumėte +',
  'Hold 0 for +, or type the number.': 'Palaikykite 0, kad įvestumėte +, arba įrašykite numerį.',
  'Your mobile ({number}) rings first, then the number': 'Pirmiausia suskamba jūsų mobilusis ({number}), tada renkamas numeris',
  'Call from my mobile': 'Skambinti iš mobiliojo',
  'This phone can’t call emergency services.': 'Šiuo telefonu negalima skambinti pagalbos tarnyboms.',
  'Call {number} from your mobile phone now.': 'Nedelsdami skambinkite {number} iš savo mobiliojo telefono.',
  'Your mobile {number} is ringing. Answer it (press 1 if asked) and you’ll be connected.':
    'Skamba jūsų mobilusis {number}. Atsiliepkite (jei paprašys, paspauskite 1) ir būsite sujungti.',
  'The call couldn’t be started. Try again.': 'Skambučio pradėti nepavyko. Bandykite dar kartą.',
  'Last call ended ({cause}).': 'Paskutinis skambutis baigtas ({cause}).',
  'Last call ended.': 'Paskutinis skambutis baigtas.',
  Status: 'Būsena',
  'Close the other tab to use the phone here.': 'Uždarykite kitą skirtuką, kad telefonas veiktų čia.',
  'Your number': 'Jūsų numeris',
  'Customers see it when you call, and calling it rings you.': 'Jį mato klientai, kai jiems skambinate, o juo paskambinus skamba jums.',
  'You have no number of your own: customers see {number}, your region’s.': 'Savo numerio neturite: klientai mato jūsų regiono numerį {number}.',
  'No number to call out from: calls to outside numbers won’t go through. Ask an administrator.':
    'Nėra numerio, iš kurio skambinti į išorę. Paprašykite administratoriaus.',
  'Your extension': 'Jūsų vidinis numeris',
  'Colleagues dial this to reach you.': 'Šiuo numeriu jums skambina kolegos.',
  'Recent calls': 'Naujausi skambučiai',
  'No calls yet': 'Skambučių dar nėra',
  'Your calls appear here.': 'Čia rodomi jūsų skambučiai.',
  'Put {number} in the dialer': 'Įrašyti {number} į numerio lauką',
  'Calls ring here while this page is open in your browser. Keep one tab open; if you open a second one, the phone stays in the first.':
    'Skambučiai skamba čia, kol šis puslapis atidarytas naršyklėje. Laikykite atidarytą vieną skirtuką: jei atidarysite antrą, telefonas liks pirmajame.',
  'If you don’t answer here, your number rings your mobile.': 'Jei čia neatsiliepsite, skambučiai į jūsų numerį suskambės mobiliajame.',
  'If an administrator adds your mobile number, calls you miss here ring it too.': 'Jei administratorius pridės jūsų mobiliojo numerį, čia praleisti skambučiai skambės ir jame.',

  // The phone's state (sidebar chip, Phone page).
  'Starting…': 'Paleidžiama…',
  'Open in another tab': 'Kitame skirtuke',
  'Connecting…': 'Jungiamasi…',
  'Ready for calls': 'Paruoštas',
  'Not connected': 'Neprijungtas',
  'connection lost': 'ryšys nutrūko',
  'The call is answered in your other tab.': 'Į skambutį atsiliepiama kitame jūsų skirtuke.',
  'Calling {number} from your other tab.': 'Skambinama numeriu {number} iš kito jūsų skirtuko.',

  // The call card.
  'Incoming call': 'Įeinantis skambutis',
  'Incoming call from {number}': 'Įeinantis skambutis: {number}',
  'Calling…': 'Skambinama…',
  'On a call': 'Vyksta pokalbis',
  'Call not put through': 'Skambutis nesujungtas',
  'Tell them: “{text}”': 'Pasakykite: „{text}“',
  'Remember to tell them this call is recorded.': 'Nepamirškite pasakyti, kad pokalbis įrašomas.',
  'Recording paused': 'Įrašymas pristabdytas',
  'Resume recording': 'Tęsti įrašymą',
  'Pause recording': 'Pristabdyti įrašymą',
  Keypad: 'Klaviatūra',
  'Hide keypad': 'Slėpti klaviatūrą',
  Answer: 'Atsiliepti',
  Decline: 'Atmesti',
  'Hang up': 'Baigti skambutį',
  // Who is calling, on the call card.
  'Save {number} as a contact': 'Išsaugoti {number} kaip kontaktą',
  Lead: 'Potencialus klientas',
  'next call {date}': 'kitas skambutis {date}',
  'Last conversations': 'Paskutiniai pokalbiai',
  'Last calls': 'Paskutiniai skambučiai',
  'New contact': 'Naujas kontaktas',

  // Setting up the phone in this browser.
  'Set up your phone': 'Nustatykite telefoną',
  'Allow these once, so calls work in this browser.': 'Leiskite tai vieną kartą, kad skambučiai veiktų šioje naršyklėje.',
  Microphone: 'Mikrofonas',
  'Needed to talk on calls. Use a headset for the best sound.': 'Reikalingas, kad galėtumėte kalbėti pokalbių metu. Geriausiam garsui naudokite ausines su mikrofonu.',
  'So you see incoming calls when this tab is in the background.': 'Kad matytumėte įeinančius skambučius, kai šis skirtukas yra fone.',
  Sound: 'Garsas',
  'Play the ring you’ll hear when someone calls.': 'Paleiskite skambėjimą, kurį girdėsite, kai kas nors skambins.',
  'Did you hear a ring? If not, check your speakers or headset.': 'Ar girdėjote skambėjimą? Jei ne, patikrinkite garsiakalbius arba ausines.',
  'Test ring': 'Išbandyti skambėjimą',
  Allow: 'Leisti',
  Allowed: 'Leista',
  Blocked: 'Užblokuota',
  'Not available': 'Nepasiekiama',
  'Not set': 'Nenustatyta',
  'Chrome blocked this. Click the icon at the left of the address bar, choose Site settings, set it to Allow, then reload the page.':
    'Chrome tai užblokavo. Spustelėkite piktogramą adreso juostos kairėje, pasirinkite „Svetainės nustatymai“, nustatykite „Leisti“ ir iš naujo įkelkite puslapį.',

  // The phone app (Your account).
  'Phone app': 'Telefono programėlė',
  'Code for {address}': 'Kodas su adresu {address}',
  'Make and take calls on your phone too. Install the app, then scan this code, or enter the address:':
    'Skambinti ir atsiliepti galite ir savo telefone. Įdiekite programėlę, tada nuskaitykite šį kodą arba įveskite adresą:',
  'Then sign in with the same email and password as here.': 'Tada prisijunkite tuo pačiu el. paštu ir slaptažodžiu kaip čia.',
  // The call card's light while a call is being recorded (the plain text is the noun).
  'now|Recording': 'Įrašoma',
};
